/* eslint-disable max-len */
import React, { useCallback, useEffect } from 'react';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { Skeleton } from '../../ui/Skeleton';
import { LoadingNavigationView } from '../account/navigation/LoadingNavigationView';
import { AppNavigator } from '../AppNavigator';
import { Page2 } from '../common/Page2';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';

const useCreatePrivateWorkspace = () => {

    const api = useResolve(ApiClient);
    const me = useResolve(ProfileModel);

    return useCallback(async () => {
        try {
            const result = await api.exec(v2.workspaces.create({
                addSelf: true,
                label: `Private Boards of ${me.name}`,
                description: 'This is a private workspace for you.',
                type: 'user',
            }));
            return result;
        }
        catch (error) {
            return null;
        }
    }, [api, me]);
};

const useResolvePrivateWorkspace = () => {
    const api = useResolve(ApiClient);
    return useCallback(async () => {
        try {
            const result = await api.exec(v2.internal.resolvePrivateWorkspace());
            return result;
        }
        catch (error) {
            return null;
        }
    }, [api]);
};

const useCreateOrResolvePrivateWorkspace = () => {
    const create = useCreatePrivateWorkspace();
    const resolve = useResolvePrivateWorkspace();
    return useCallback(async () => {
        return (await create()) ?? (await resolve());
    }, [create, resolve]);
};

export const CreatePrivateWorkspacePage = () => {

    const onCreateOrResolve = useCreateOrResolvePrivateWorkspace();
    const nav = useResolve(AppNavigator);

    useEffect(() => {
        onCreateOrResolve()
            .then(x => {
                nav.go(`~/${x.id}/boards`);
            });
    }, [onCreateOrResolve, nav]);

    return <Page2 navigation={LoadingNavigationView}>
        <Page2.Scroll>
            <Page2.Header float>
                <Page2.Title>
                    <Skeleton width="10" />
                </Page2.Title>
            </Page2.Header>
            <Page2.Content>
            </Page2.Content>
        </Page2.Scroll>
    </Page2>;
};
